export default (theme) => ({
  container: {
    height: 340,
    width: '100%',
    borderRadius: 28,
    [theme.breakpoints.down('xl')]: {
      height: 300,
    },
  },
});
